import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import HomeBanner from 'src/entities/HomeBanner';

export interface ApiHomeBannerResponse {
  banner: {
    image: string;
    url: string;
  };
}

export class HomeBannerFactory extends BaseFactory<HomeBanner> {
  public toEntity(args: ApiHomeBannerResponse): HomeBanner {
    return new HomeBanner({
      image: args.banner.image,
      url: args.banner.url,
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/HomeBannerFactory.tsx